module.exports = __webpack_public_path__ + "static/media/project.ea541416.svg";